import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['accreditationNumber', 'certificateId', 'cipherKey']

  fillFromFacility(event) {
    const opt = event.target.selectedOptions[0]
    this.accreditationNumberTarget.value = opt?.dataset.accreditationNumber ?? ''
    this.certificateIdTarget.value       = opt?.dataset.certificateId       ?? ''
    this.cipherKeyTarget.value           = opt?.dataset.cipherKey           ?? ''
  }
}
